<mat-form-field appearance="outline">
    <mat-label>Vis antal</mat-label>
    <input matInput type="number" [(ngModel)]="showCount" (ngModelChange)="ngOnInit()"
        [ngModelOptions]="{'updateOn':'blur'}" enterNavigation>
</mat-form-field>
<div style="display: flex;gap:2rem">
    <div style="display: flex;flex-direction: column;" [style.color]="textColor">
        <h4 style="padding: none;margin-bottom: 0;">@if (ranking == 'highest') {Højeste} @else {Laveste} ordrebeholdning</h4>
        <table style="width: 350px;" [style.color]="textColor">
            <thead>
                <tr>
                    <th></th>
                    <th> Realiseret </th>
                    <th> Budget </th>
                    <th> I mdr </th>
                </tr>
            </thead>
            <tbody>
                @for (item of orderBacklog; track $index) {
                <tr>
                    <td>{{item.consultantInitials}}</td>
                    <td>{{item.realizedRevenue| number: '1.0-0'}}</td>
                    <td>{{item.budget| number: '1.0-0'}}</td>
                    <td>{{item.months}}</td>
                </tr>
                }
            </tbody>
        </table>
    </div>

    <div style="display: flex;flex-direction: column;" [style.color]="textColor">
        <h4 style="padding: none;margin-bottom: 0;">@if (ranking == 'highest') {Højeste} @else {Laveste} totalsalg</h4>
        <table style="width: 250px;">
            <thead>
                <tr>
                    <th></th>
                    <th> Realiseret </th>
                    <th> Budget </th>
                </tr>
            </thead>
            <tbody>
                @for (item of totalRevenue; track $index) {
                <tr>
                    <td>{{item.consultantInitials}}</td>
                    <td>{{item.realizedRevenue| number: '1.0-0'}}</td>
                    <td>{{item.budget| number: '1.0-0'}}</td>
                </tr>
                }
            </tbody>
        </table>
    </div>

    <div style="display: flex;flex-direction: column;" [style.color]="textColor">
        <h4 style="padding: none;margin-bottom: 0;">
            @if (ranking == 'highest') {Højeste} @else {Laveste} bidrag til LEAD efter løn og fællesomk. </h4>
        <table style="width: 600px;">
            <thead>
                <tr>
                    <th></th>
                    <th>Personlig omsætning</th>
                    <th>Løn</th>
                    <th>Fællesomk.</th>
                    <th>Bidrag</th>
                </tr>
            </thead>
            <tbody>
                @for (item of totalRevenueAfterExpenses; track $index) {
                <tr>
                    <td>{{item.consultantInitials}}</td>
                    <td>{{item.sales | number: '1.0-0'}}</td>
                    <td>{{item.salary === null ? '-' : (item.salary + (item.bonus ?? 0) | number: '1.0-0')}}</td>
                    <td>{{item.sharedExpenses === null ? '-' : (item.sharedExpenses | number: '1.0-0')}}</td>
                    <td>{{item.contribution | number: '1.0-0'}}</td>
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>
